import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { UiV2Service } from './ui-v2.service';

/** Matches the v2 route tree only when the v2 switch is on. */
export const v2On: CanMatchFn = () => inject(UiV2Service).isEnabled();
